function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { sans as zoram, lineHeight, fontSize14, fontWeightNormal, fontWeightSemiBold, fontWeightBold } from "@churchofjesuschrist/eden-style-constants";
import shared from "./shared";
const Container4 = styled.div.withConfig({
  componentId: "sc-1u44evz-0"
})(["font-family:", ";font-weight:", ";line-height:", ";font-size:", ";", ";& b,& strong{font-weight:", ";}"], zoram, props => props.emphasized ? fontWeightSemiBold : fontWeightNormal, lineHeight, fontSize14, shared, fontWeightBold);

const Text4 = _ref => {
  let {
    children,
    emphasized = false,
    as = "div",
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Container4, _extends({
    emphasized: emphasized,
    as: as
  }, props), children);
};

Text4.propTypes = {
  /** Content */
  children: PropTypes.node.isRequired,

  /** Whether the styles should display as emphasized */
  emphasized: PropTypes.bool,

  /** What html tag or custom react element to render the text as */
  as: PropTypes.node
};
export default Text4;